'use client';

import { Suspense, type ReactElement, type ReactNode } from 'react';
import { cn } from '@/lib/utils';
/** @sfdc-extension-line SNK */
import { BURGER_MENU_CONTENT_SLOTS_MAX_WIDTH_CLASS } from '@/extensions/snk/lib/utils';
import { BurgerMenuSubmenuContentSkeleton } from '../skeleton';

type BurgerMenuSubmenuPdContentProps = {
    children: ReactNode;
    testId?: string;
    fallback?: ReactNode;
};

export function BurgerMenuSubmenuPdContent({
    children,
    testId,
    fallback = <BurgerMenuSubmenuContentSkeleton />,
}: BurgerMenuSubmenuPdContentProps): ReactElement {
    return (
        <div className={cn(BURGER_MENU_CONTENT_SLOTS_MAX_WIDTH_CLASS)} data-testid={testId}>
            <Suspense fallback={fallback}>{children}</Suspense>
        </div>
    );
}
